import { render, staticRenderFns } from "./WizardHandoffPendingStep.vue?vue&type=template&id=cb7f9b18&scoped=true"
import script from "./WizardHandoffPendingStep.vue?vue&type=script&lang=js"
export * from "./WizardHandoffPendingStep.vue?vue&type=script&lang=js"
import style0 from "./WizardHandoffPendingStep.vue?vue&type=style&index=0&id=cb7f9b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7f9b18",
  null
  
)

export default component.exports